import { Box, styled, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconUser } from 'assets/img';
import { theme } from 'redesign/theme';
import {
  CardHeader,
  HoverPill,
  StyledIdScanCard,
  StyledTextPlaceholder,
} from '../id-scan-card-shared-style/id-scan-card-shared-style';
import { IdCardPlaceholderProps } from '../types';

export const FrontIdScanCard = ({ onClick, image }: IdCardPlaceholderProps) => {
  const { t } = useTranslation('web-common');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledIdScanCard elevation={0} onClick={onClick} image={image || undefined}>
      {!image ? (
        <>
          <CardHeader>
            <CardAvatar>
              <AvatarIcon />
            </CardAvatar>
            <StyledTextContainer>
              <StyledTextPlaceholder width="100%" height="20px" />
              <StyledTextPlaceholder width="40%" height="10px" />
            </StyledTextContainer>
          </CardHeader>
          <CardFooter>
            <StyledTextPlaceholder width="100%" height="10px" />
            <StyledTextPlaceholder width="40%" height="10px" />
          </CardFooter>
        </>
      ) : null}
      <HoverPill className={isMobile ? 'hover-pill-mobile' : 'hover-pill'}>
        {t('id-submission.id-scan.front-side.hover-pill')}
      </HoverPill>
    </StyledIdScanCard>
  );
};

const CardAvatar = styled(Box)(({ theme }) => ({
  width: 80,
  height: 80,
  flexShrink: 0,
  backgroundColor: theme.palette.lwBlack[10],
  borderRadius: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const AvatarIcon = styled(IconUser)(({ theme }) => ({
  width: 40,
  height: 40,
  fill: theme.palette.lwBlack[30],
  path: {
    stroke: 'none',
  },
}));

const StyledTextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  width: '100%',
}));

const CardFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  marginTop: theme.spacing(6),
  width: '100%',
  flex: 1,
  minHeight: 0,
  justifyContent: 'flex-end',
}));
